import { IrIncomeTypeUsecase, TransactionCode, UserDefinedRow, CarBenefitUsecase } from "../../model";
import { IncomeTypeMetadata, IncomeTypesLogic, } from "../../logic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";

/** Client-side logic for IrIncomeTypeUsecase  */
export class IrIncomeTypeUsecaseLogic extends BaseUsecaseLogic {

  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   */
  public updateUsecase(row: UserDefinedRow): void {
    const data: IrIncomeTypeUsecase = row.data;
    // Get code data by kind first (new version) and then using the old method.
    const codeData = this.getCodeDataByNumber(data?.irData?.code) ?? this.getCodeDataByTransaction(data?.kind);
    if (codeData) {
      data.irData = data.irData ?? {};
      data.irData.code = codeData.code;
      data.kind = codeData.transactionCode;
    }
  }

  /** Gets validation message for IrIncomeTypeUsecase  */
  public getUcValidation(row: UserDefinedRow): UsecaseValidationMessage {
    const data: IrIncomeTypeUsecase = row.data;
    const codeData = this.getCodeDataByNumber(data?.irData?.code) ?? this.getCodeDataByTransaction(data?.kind);
    if (!codeData) {
      return {
        type: "error",
        msg: "SALAXY.VALIDATION.Usecases.noIrIncomeType",
      };
    }
    if (codeData.transactionCode === TransactionCode.CarBenefit) {
      const carBenefit: CarBenefitUsecase = data.irData.carBenefit || {};
      if (carBenefit.emissionsValue < 0 || carBenefit.emissionsValue > 100) {
        return {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.carBenefit.invalidEmissionValues",
        };
      }
      if (!carBenefit.ageGroup || carBenefit.kilometers == null) {
        return {
          type: "error",
          msg: "SALAXY.VALIDATION.Usecases.carBenefit.default",
        };
      }
    }

    return null;
  }

  private getCodeDataByNumber(code: number): IncomeTypeMetadata {
    if (!code) {
      return null;
    }

    return IncomeTypesLogic.getAll().find( (x) => x.code === code);
  }

  private getCodeDataByTransaction(transactionCode: TransactionCode): IncomeTypeMetadata {
    if ( !transactionCode ||
        transactionCode === TransactionCode.Unknown ||
        (transactionCode as any) === "undefined" ) {
      return null;
    }
    return IncomeTypesLogic.getAll().find( (x) => x.transactionCode === transactionCode);
  }

  private isIrIncomeTypeLabel(label: string): boolean {
    return IncomeTypesLogic.getAll().some( (x) => x.label === label);
  }
}
